import { Box, Divider } from "@mui/material";
import { ProjectDetailDto, ProjectDto } from "../../../api/psc";
import ExpandableCard from "../../../components/shared/ExpandableCard";
import ProjectDetailSms from "../Shared/ProjectDetailSms";

// updated
export default function ProjectDetailMobileSms(props: {
    projects: ProjectDto[] | ProjectDetailDto[];
}) {
    return (
        <ExpandableCard title="ارسال پیامک">
            <Box>
                <Divider sx={{ mt: 2, mb: 2 }}></Divider>
                <ProjectDetailSms projects={props.projects}></ProjectDetailSms>
            </Box>
        </ExpandableCard>
    );
}
